import React from "react";
import { useNavigate } from "react-router-dom";

interface DashboardSummaryProps {
  summary: any;
}

const DashboardSummary: React.FC<DashboardSummaryProps> = ({ summary }) => {
  const navigate = useNavigate();

  if (!summary) return null;

  const stats = [
    {
      title: "Total Alerts",
      value: summary.total_alerts || 0,
      icon: "fa-bell",
      color: "is-info",
    },
    {
      title: "Pending Alerts",
      value: summary.pending_alerts || 0,
      icon: "fa-clock",
      color: "is-warning",
    },
    {
      title: "Bullish Signals",
      value: summary.bullish_alerts || 0,
      icon: "fa-arrow-up",
      color: "is-success",
    },
    {
      title: "Bearish Signals",
      value: summary.bearish_alerts || 0,
      icon: "fa-arrow-down",
      color: "is-danger",
    },
    {
      title: "Patterns Today",
      value: summary.total_patterns_today || 0,
      icon: "fa-chart-line",
      color: "is-primary",
    },
    {
      title: "Active Companies",
      value: summary.active_companies || 0,
      icon: "fa-building",
      color: "is-link",
    },
  ];

  const handleStatClick = (title: string) => {
    if (title === "Active Companies") {
      navigate("/dashboard/companies");
    }
  };

  return (
    <div className="dashboard-summary mb-5">
      <div className="columns is-multiline">
        {stats.map((stat, index) => (
          <div className="column is-2" key={index}>
            <div
              className={`box has-text-centered stat-card ${stat.color} ${stat.title === "Active Companies" ? "is-clickable" : ""}`}
              onClick={() => handleStatClick(stat.title)}
              style={stat.title === "Active Companies" ? { cursor: "pointer" } : {}}
            >
              <div className="stat-icon">
                <span className="icon is-large">
                  <i className={`fa ${stat.icon} fa-2x`}></i>
                </span>
              </div>
              <div className="stat-value">
                <p className="title is-4">{stat.value.toLocaleString()}</p>
              </div>
              <div className="stat-label">
                <p className="subtitle is-6">{stat.title}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      {summary.last_updated && (
        <p className="has-text-grey has-text-right is-size-7">
          Last updated: {new Date(summary.last_updated).toLocaleString()}
        </p>
      )}
    </div>
  );
};

export default DashboardSummary;
